import React from "react";

const RoomCalculator = ({ rooms, setRooms, btnColor, labelColor }) => {
  const addRoom = () => {
    setRooms([...rooms, { name: "", length: 0, width: 0 }]);
  };

  const removeRoom = (index) => {
    setRooms(rooms.filter((_, i) => i !== index));
  };

  const updateRoom = (index, field, value) => {
    const updated = rooms.map((room, i) =>
      i === index ? { ...room, [field]: value } : room
    );
    setRooms(updated);
  };

  const totalSurface = rooms.reduce(
    (total, room) => total + room.length * room.width,
    0
  );

  const clr = btnColor || "#000";
  const lbl = labelColor || "#fff";

  const numInput =
    "w-full py-2 px-2.5 bg-white border border-neutral-200 rounded-lg text-sm font-semibold text-neutral-900 placeholder:text-neutral-500 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all text-center";

  return (
    <div className="flex flex-col gap-2">
      {rooms.map((room, index) => {
        const surface = room.length * room.width;
        return (
          <div key={index} className="bg-neutral-50 rounded-xl p-3 border border-neutral-100">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2">
              <input
                type="text"
                placeholder={`Ex : Salon, Chambre, Cuisine...`}
                className="text-[13px] font-semibold bg-white border border-neutral-200 rounded-lg px-2.5 py-1.5 text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:border-transparent transition-all w-full sm:w-2/3"
                value={room.name}
                onChange={(e) => updateRoom(index, "name", e.target.value)}
              />
              <div className="flex items-center gap-2 self-end sm:self-auto">
                <span className="text-xs font-bold text-neutral-900 bg-neutral-200 px-2 py-0.5 rounded-md whitespace-nowrap">
                  {surface.toFixed(1)} m²
                </span>
                {rooms.length > 1 && (
                  <button
                    type="button"
                    className="w-5 h-5 rounded-md bg-neutral-200 text-neutral-600 hover:bg-red-100 hover:text-red-500 flex items-center justify-center transition-colors shrink-0"
                    onClick={() => removeRoom(index)}
                  >
                    <svg className="w-2.5 h-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="flex-1">
                <label className="text-[9px] font-bold text-neutral-600 uppercase tracking-wider mb-0.5 block">Long.</label>
                <div className="relative">
                  <input
                    type="number" min="0" step="0.1" placeholder="0"
                    className={`${numInput} pr-6`}
                    value={room.length || ""}
                    onChange={(e) => updateRoom(index, "length", parseFloat(e.target.value) || 0)}
                  />
                  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[9px] font-bold text-neutral-600">m</span>
                </div>
              </div>
              <span className="text-neutral-500 mt-3.5 text-[10px] font-black">x</span>
              <div className="flex-1">
                <label className="text-[9px] font-bold text-neutral-600 uppercase tracking-wider mb-0.5 block">Larg.</label>
                <div className="relative">
                  <input
                    type="number" min="0" step="0.1" placeholder="0"
                    className={`${numInput} pr-6`}
                    value={room.width || ""}
                    onChange={(e) => updateRoom(index, "width", parseFloat(e.target.value) || 0)}
                  />
                  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[9px] font-bold text-neutral-600">m</span>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <button
        type="button"
        className="w-full py-2 rounded-xl text-xs font-semibold border-2 border-dashed border-neutral-300 text-neutral-600 hover:border-neutral-500 hover:text-neutral-800 transition-all"
        onClick={addRoom}
      >
        + Ajouter une pièce
      </button>

      <div
        className="flex items-center justify-between px-3.5 py-2.5 rounded-xl text-sm font-bold"
        style={{ backgroundColor: clr, color: lbl }}
      >
        <span>Total</span>
        <span className="text-base">{totalSurface.toFixed(1)} m²</span>
      </div>
    </div>
  );
};

export default RoomCalculator;
